import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../shadcn-ui/card';
import { ChevronRight } from 'lucide-react';
import { Separator } from '../shadcn-ui/separator';

const DryingLotCard = ({ lot }) => {
  return (
    <Link
      to={lot?.drying_lot?.drying_start_time ? `/drying-lots/in-progress/${lot._id}` : `/drying-lots/start/${lot._id}`}
    >
      <Card className="flex items-center justify-between p-3">
        <div className="flex flex-1 flex-col">
          <div className="font-medium">{lot?.lotname}</div>
          <div className="">{lot?.estate_name?.name}</div>
          <div className="flex items-center gap-2 tracking-tight text-sm">
            {lot?.drying_lot?.drying_start_time ? `${lot?.drying_days} days since drying` : 'Drying yet to start'}
            {lot?.drying_lot?.drying_start_time && (
              <>
                <Separator orientation="vertical" className="h-4 w-px bg-gray-600" />
                {lot?.active_drying_count && `${lot?.active_drying_count} beds active`}
              </>
            )}
          </div>
        </div>
        <button className="mr-1 flex-shrink-0">
          <ChevronRight className="h-5 w-5" />
        </button>
      </Card>
    </Link>
  );
};

export default DryingLotCard;
